export default "__VITE_ASSET__Bby7feja__"